import React, { useState, useCallback } from "react";
import FormSkel from "../../../../../components/Modals/FormSkel";

const ConfirmRecoverSettingsForm = ({ isOpen, onClose, onSubmit, generateTaskId }) => {
  const [startAt, setStartAt] = useState("");

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    const task = {
      id: generateTaskId(),
      taskType: "RECOVER_SETTINGS",
      startAt: startAt || null,
      datetimeType: startAt ? "single" : null,
    };
    
    onSubmit(task);
    setStartAt("");
  }, [startAt, onSubmit, generateTaskId]);

  const handleClose = useCallback(() => {
    setStartAt("");
    onClose();
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <FormSkel
      headerText="Potwierdź przywrócenie ustawień domyślnych"
      handleClose={handleClose}
      acceptForm="true"
      customName="Przywróć"
      warning={true}
    >
      <div>
        <form onSubmit={handleSubmit} id="modal-form">
          <div className="form-group">
            <div className="alert alert-warning border-warning shadow-sm" role="alert">
              <div className="d-flex align-items-center mb-2">
                <strong className="h6 mb-0 text-dark">Uwaga! Ostrzeżenie przywracania ustawień</strong>
              </div>
              <p className="mb-0 small text-dark">
                Przywrócenie ustawień domyślnych spowoduje zresetowanie konfiguracji 
                płyty sterującej VMC do wartości fabrycznych.
              </p>
            </div>
            <p className="text-danger font-weight-bold text-center my-3">
              Czy na pewno chcesz przywrócić ustawienia domyślne?
            </p>
          </div>
          
          <div className="form-group mb-0">
            <label htmlFor="datetimeRecover" className="form-label font-weight-bold">
              Kiedy wykonać przywrócenie (opcjonalnie)
            </label>
            <input
              type="datetime-local"
              className="form-control"
              id="datetimeRecover"
              value={startAt}
              onChange={(e) => setStartAt(e.target.value)}
            />
            <small className="form-text text-muted">
              Pozostaw puste dla natychmiastowego wykonania.
            </small>
          </div>
        </form>
      </div>
    </FormSkel>
  );
};

export default ConfirmRecoverSettingsForm;
